<template>
    <v-container fluid px-3 pt-3>
        <v-row row wrap>
            <v-col cols="12">
                <h3>Divorce Certificate Order - Wyoming Only</h3>
            </v-col>
        </v-row>
        <v-row row wrap v-if="isCertReturned">
            <v-col cols="12">
                <h5 class="red--text">
                    Your certificate order was returned for further information. You will need to respond to the below message and re-submit your request.
                    If you do not respond, your request for a certificate will be canceled on {{orderStatusExpireDate}}. <span class="font-weight-bold">Any fees already paid for this order cannot be refunded.</span>
                    If this order is canceled, you will need to create a completely new order, although you may use the same Portal account to do so.
                </h5>
            </v-col>
        </v-row>
        <v-row row wrap v-if="mailMessage">
            <v-col cols="12">
                <h5 style="background-color: #FFFF88">{{ mailMessage }}</h5>
            </v-col>
        </v-row>
        <v-divider></v-divider>
        <v-row>
            <v-col cols="12">
                <v-form v-model="divorceForm" ref="form">
                    <v-container>
                        <v-row align="center">
                            <v-col align-self="center" cols="12">
                                <h3>WYOMING DIVORCE RECORD - Record(s) Requested (${{certCost()}} Each)</h3>
                            </v-col>
                            <v-col align-self="center" cols="6">
                                <v-text-field :disabled="!isCertNew" v-model="numberOfCertificates" @keypress="filterNumbers($event)" type="number"
                                              label="(#) Divorce Certificates" min="0" max="50" required :rules="requiredRule && numCertRule" />
                            </v-col>
                        </v-row>
                        <certificate-payment ref="certPaymentRef" :numberOfCertificates="numberOfCertificates" :numberOfAffidavits="0" @submit="continueToPayment" @resubmit="redirectToHome" ></certificate-payment>
                        <v-row>
                            <v-col align-self="center" cols="12">
                                <h4>Complete information as it appears on the Record</h4>
                            </v-col>
                            <v-divider></v-divider>
                        </v-row>
                        <v-layout row wrap>
                            <v-flex xs12 sm4 px-2>
                                <v-text-field :disabled="!canEdit" label="Husband/Wife/Spouse - Full First Name" v-model="divorceOrder.firstName1" required :rules="requiredRule"></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm4 px-2>
                                <v-text-field :disabled="!canEdit" label="Full Middle Name" v-model="divorceOrder.middleName1"></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm4 px-2>
                                <v-text-field :disabled="!canEdit" label="Full Last Name (At Time of Divorce)" v-model="divorceOrder.lastName1" required :rules="requiredRule"></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm4 px-2>
                                <v-text-field :disabled="!canEdit" label="Husband/Wife/Spouse - Full First Name" v-model="divorceOrder.firstName2" required :rules="requiredRule"></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm4 px-2>
                                <v-text-field :disabled="!canEdit" label="Full Middle Name" v-model="divorceOrder.middleName2"></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm4 px-2>
                                <v-text-field :disabled="!canEdit" label="Full Last Name (At Time of Divorce)" v-model="divorceOrder.lastName2" required :rules="requiredRule"></v-text-field>
                            </v-flex>
                        </v-layout>
                        <v-layout row wrap>
                            <v-flex xs12 sm6 px-2>
                                <v-text-field
                                    :disabled="!canEdit"
                                    label="Divorce Date (If exact date is not known, enter approximate date.)"
                                    type="date" v-model="divorceOrder.marriageDivorceDate" required :rules="requiredRule"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm6 px-2>
                                <v-text-field
                                    :disabled="!canEdit"
                                    label="Place of Divorce (enter city and/or county)"
                                    v-model="divorceOrder.marriageDivorcePlace" required :rules="requiredRule"
                                ></v-text-field>
                            </v-flex>
                        </v-layout>
                        <v-layout row wrap>
                            <v-flex xs12>
                                <h4>Requestors Information</h4>
                            </v-flex>
                            <v-flex xs12 sm4 px-2>
                                <v-text-field :disabled="!canEdit" label="Full First Name" v-model="divorceOrder.reqFirstName" required :rules="requiredRule"></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm4 px-2>
                                <v-text-field :disabled="!canEdit" label="Full Middle Name" v-model="divorceOrder.reqMiddleName"></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm4 px-2>
                                <v-text-field :disabled="!canEdit" label="Full Last Name (Exactly as shown on drivers license)" v-model="divorceOrder.reqLastName" required :rules="requiredRule"></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                                <addr id="mailingAddress" :disabled="!canEdit" :isRequired="true" customAddressLabelPrepend="Mailing " ref="mailingAddressRef"></addr>
                            </v-flex>
                        </v-layout>
                        <v-layout row wrap>
                            <v-flex xs12 sm5 px-2>
                                <v-text-field :disabled="!canEdit" label="Contact Phone Number" v-model="divorceOrder.phone" v-mask="'###-###-####'"></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm2 align-self-center class="text-center">
                                AND/OR
                            </v-flex>
                            <v-flex xs12 sm5 px-2>
                                <v-text-field :disabled="!canEdit" label="Contact Email Address" v-model="divorceOrder.email"></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm6>
                                <b>State your relationship to the person(s) named on the certificate(s) requested, or enter Self:</b>
                            </v-flex>
                            <v-flex xs12 sm6 px-2>
                                <v-text-field :disabled="!canEdit" label="Relationship" v-model="divorceOrder.relationship"></v-text-field>
                            </v-flex>
                            <v-flex xs12 px-2>
                                <v-text-field :disabled="!canEdit" label="Purpose for requesting certificate" v-model="divorceOrder.purpose" required :rules="requiredRule" counter="500" maxlength="500"></v-text-field>
                            </v-flex>
                        </v-layout>
                        <v-row>
                            <v-col cols="12">
                                <b>ATTACH IMAGE OF A VALID GOVERNMENT ISSUED ID HERE<br />
                                    (Driver’s License, State ID Card, Passport, Tribal ID)<br />
                                    *If signature is located on the back, provide images of both sides</b>
                            </v-col>
                        </v-row>
                        <imageList ref="imageListRef" :disabled="!canEdit" @send-message="saveUnfinished()"></imageList>
                        <v-layout row wrap>
                            <v-flex xs12 md3 align-self-center>
                                <b>Please Enter Full Name (Must be 18 or older):</b>
                            </v-flex>
                            <v-flex xs10 md7 px-2>
                                <v-text-field :disabled="!canEdit" label="Full Name" v-model="divorceOrder.signature" required :rules="requiredRule"></v-text-field>
                            </v-flex>
                            <v-flex xs2 md2 px-2>
                                <v-text-field :disabled="true" validate-on-blur type="date" label="Date" v-model="divorceOrder.date"></v-text-field>
                            </v-flex>
                            <v-flex xs12 md10 align-self-center v-if="canEdit">
                                I certify the information provided for this certificate is correct to the best of my knowledge and belief.
                                I also acknowledge that submitting this form constitutes an electronic signature and will be considered as a handwritten signature for all purposes and shall have the same force and effect as a handwritten signature.
                            </v-flex>
                            <v-flex xs12 md2 px-3 align-self-center v-if="canEdit">
                                <v-checkbox required :rules="requiredRule"></v-checkbox>
                            </v-flex>
                        </v-layout>
                        <v-row v-if="errors.length > 0">
                            <v-col cols="12">
                                Please Correct the Following Errors:
                                <ul>
                                    <li class="red--text" v-for="error in errors" :key="error">
                                        {{error}}
                                    </li>
                                </ul>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col cols="12" v-if="isSaved">
                                Your Order has been saved. To continue work on it find it in your inbox. The ID for this order is {{divorceOrder.portalMarriageDivorceOrderId}}.
                            </v-col>
                            <v-col cols="12" v-if="isSubmitted">
                                Your Order has been submitted. Once it has been approved or denied you will see it in your inbox. The ID for this order is {{divorceOrder.portalMarriageDivorceOrderId}}.
                            </v-col>
                        </v-row>
                        <v-layout row wrap v-if="canEdit">
                            <v-flex xs12 sm3 md2 lg2 xl2>
                                <v-btn @click="submit()" :disabled="!divorceForm || isLoading || isSubmitted" color="secondary">SUBMIT</v-btn>
                            </v-flex>
                            <v-flex xs12 sm6 md8 lg8 xl8 v-if="canEdit && !isCertNew" style="margin-top: -27px">
                                <contact-vss ref="responseContactVss" :operationType="operationType" :subOperationType="responseContactOperation" :requestId="divorceOrder.portalMarriageDivorceOrderId" :modType="30"></contact-vss>
                            </v-flex>
                            <v-flex cxs12 sm3 md2 lg2 xl2>
                                <v-btn @click="saveUnfinished()" :disabled="isLoading || isSubmitted" color="secondary">SAVE UNFINISHED</v-btn>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-form>
            </v-col>
        </v-row>
        <contact-vss :operationType="operationType" :requestId="divorceOrder.portalMarriageDivorceOrderId" :modType="30"></contact-vss>
    </v-container>
</template>

<script>
import Addr from '@/components/Address'
import certService from '@/services/certificateService'
import lookupService from '@/services/lookupService'
import ImageList from '@/components/CertificateImages'
import mailService from '@/services/mailService'
import { mask } from 'vue-the-mask'
import CertificatePayment from '@/components/CertificatePayment.vue'
import ContactVss from '../components/ContactVss.vue'

export default {
    components: {
        Addr,
        ImageList,
        CertificatePayment,
        ContactVss
    },
    directives: {
        mask
    },
    data: () => {
        return {
            divorceForm: false,
            subtotalData: 0,
            numberOfCertificates: 1,
            prettySubtotal: null,
            prettyProcessingFee: null,
            processingFee: null,
            prettyTotal: null,
            total: null,
            isSaved: false,
            isSubmitted: false,
            isLoading: false,
            paymentId: null,
            cities: [],
            counties: [],
            errors: [],
            images: null,
            savedImages: null,
            deleteSavedImages: false,
            requiredRule: [v => !!v || 'Required'],
            numCertRule: [v => v > 0 || 'Cannot be less than 1', v => v <= 50 || 'Cannot be more than 50'],
            divorceOrder: {
                portalMarriageDivorceOrderId: null,
                modType: '30',
                numCerts: null,
                firstName1: null,
                middleName1: null,
                lastName1: null,
                firstName2: null,
                middleName2: null,
                lastName2: null,
                reqFirstName: null,
                reqMiddleName: null,
                reqLastName: null,
                mailingAddress: {},
                phone: null,
                email: null,
                relationship: null,
                purpose: null,
                signature: null,
                date: null,
                isCompleted: false,
                marriageDivorceDate: null,
                marriageDivorcePlace: null
            },
            orderStatus: null,
            orderStatusExpireDate: null,
            mailMessage: null,
            operationType: mailService.OperationEnum.CertificateOrder,
            responseContactOperation: mailService.SubOperationEnum.ResponseContact
        }
    },
    computed: {
        isCertNew () {
            return this.orderStatus === certService.CertificateStatusEnum.New || this.orderStatus === null
        },
        canEdit () {
            switch (this.orderStatus) {
            case null:
            case certService.CertificateStatusEnum.New:
            case certService.CertificateStatusEnum.MoreInformationRequested:
                return true
            default:
                return false
            }
        },
        isCertReturned () {
            return this.orderStatus === certService.CertificateStatusEnum.MoreInformationRequested
        }
    },
    mounted () {
        window.scrollTo(0, 0)
        lookupService.GetWyomingCities(this.$http).then(response => {
            this.cities = response.data
        })
        lookupService.GetWyomingCounties(this.$http).then(response => {
            this.counties = response.data
        })

        this.$refs.certPaymentRef.setup('30')

        if (this.$route.query.orderId != null) {
            certService.getMarriageDivorceOrderById(this.$http, this.$route.query.orderId, this.divorceOrder.modType).then(response => {
                if (response.data != null) {
                    this.setupOrder(response.data)
                    this.$refs.imageListRef.loadImages('30', this.divorceOrder.portalMarriageDivorceOrderId)
                }
            })
            this.loadMailMessage()
        }

        this.divorceOrder.date = this.dateToYYYYMMDD(new Date())
    },
    methods: {
        loadMailMessage () {
            mailService.GetMailByRequestId(this.$http, this.$route.query.orderId).then(res => {
                if (res.data && res.data.length > 0) {
                    this.mailMessage = res.data[res.data.length - 1].message
                }
            })
        },
        submit () {
            var confirmMsg = this.isCertReturned
                ? 'Your updated order will be submitted.'
                : 'Proceed to order payment. Once your order and payment are submitted you will be unable to make any changes. Do you want to proceed?'
            if (!confirm(confirmMsg)) { return }

            this.isLoading = true
            this.errors = []

            this.divorceOrder.numCerts = parseInt(this.numberOfCertificates) || 0

            if (this.divorceOrder.numCerts < 1) {
                this.errors.push('Number of Certificates Requested is Required')
            }
            if (this.divorceOrder.numCerts > 50) {
                this.errors.push('Cannot request more than 50 Certificates')
            }
            if (!this.divorceOrder.phone && !this.divorceOrder.email) {
                this.errors.push('Either a Contact Phone Number or Contact Email Address Must be Provided')
            }
            if (this.$refs.mailingAddressRef.checkFields()) {
                this.errors.push('Mailing address is Required')
            }
            if (this.$refs.imageListRef.mediaList.length === 0) {
                this.errors.push('At Least One Image is Required')
            }

            if (this.divorceForm && this.errors.length === 0) {
                this.divorceOrder.mailingAddress = this.$refs.mailingAddressRef.placeDTO
                this.divorceOrder.mailingAddress.county = (this.divorceOrder.mailingAddress.county || '').replace(' County', '')
                this.divorceOrder.isCompleted = true
                this.divorceOrder.date = this.dateToYYYYMMDD(new Date())
                certService.sendMarriageDivorceCertOrder(this.$http, this.divorceOrder, '30').then(response => {
                    if (response.data) {
                        let validationResult = response.data.validationResult
                        this.divorceOrder.portalMarriageDivorceOrderId = response.data.portalMarriageDivorceOrderId
                        this.addOrderIdToRoute(this.divorceOrder.portalMarriageDivorceOrderId)
                        this.isSaved = true
                        if (validationResult.isValid) {
                            if (this.$refs.responseContactVss) this.$refs.responseContactVss.sendMessage()
                            this.$refs.certPaymentRef.submit(this.divorceOrder.portalMarriageDivorceOrderId)
                        } else {
                            this.errors = validationResult.errorMessages
                        }
                    } else {
                        alert('Unexpected error occurred, please sumbit your order again.')
                    }
                    this.isLoading = false
                })
            } else {
                this.isLoading = false
            }
        },
        saveUnfinished () {
            this.isLoading = true
            this.divorceOrder.isCompleted = false
            this.divorceOrder.date = null
            this.divorceOrder.numCerts = parseInt(this.numberOfCertificates) || 0
            this.divorceOrder.mailingAddress = this.$refs.mailingAddressRef.placeDTO
            this.divorceOrder.mailingAddress.county = (this.divorceOrder.mailingAddress.county || '').replace(' County', '')
            certService.sendMarriageDivorceCertOrder(this.$http, this.divorceOrder, '30').then(response => {
                if (response.data) {
                    this.divorceOrder.portalMarriageDivorceOrderId = response.data.portalMarriageDivorceOrderId
                    this.addOrderIdToRoute(this.divorceOrder.portalMarriageDivorceOrderId)
                    this.isSaved = true
                    this.divorceOrder.date = this.dateToYYYYMMDD(new Date())
                    this.$refs.imageListRef.uploadImage(this.divorceOrder.portalMarriageDivorceOrderId, '30')
                } else {
                    alert('Unexpected error occurred, please try again.')
                }
                this.isLoading = false
            })
        },
        setupOrder (dto) {
            this.divorceOrder = dto
            this.numberOfCertificates = dto.numCerts
            this.$refs.mailingAddressRef.placeDTO = dto.mailingAddress
            this.divorceOrder.date = this.dateToYYYYMMDD(new Date())
            this.divorceOrder.marriageDivorceDate = dto.marriageDivorceDate != null ? this.dateToYYYYMMDD(new Date(dto.marriageDivorceDate)) : dto.marriageDivorceDate
            this.divorceOrder.portalMarriageDivorceOrderId = dto.portalMarriageDivorceOrderId
            this.$refs.form.validate()
            this.certStatus()
        },
        dateToYYYYMMDD (d) {
            return new Date(d.getTime() - (d.getTimezoneOffset() * 60 * 1000)).toISOString().split('T')[0]
        },
        continueToPayment (paymentId) {
            this.$router.push('payment-processing/' + paymentId)
        },
        redirectToHome () {
            this.$router.push('order-certificate')
        },
        resubmit () {
            this.isSubmitted = true
        },
        certCost: function () {
            if (this.$refs.certPaymentRef) {
                return this.$refs.certPaymentRef.certCost
            } else {
                return null
            }
        },
        certStatus () {
            certService.getOrderStatus(this.$http, this.divorceOrder.portalMarriageDivorceOrderId, lookupService.ModuleTypeEnum.Divorce).then(res => {
                if (res.data) {
                    this.orderStatus = res.data.orderStatusId
                    this.orderStatusExpireDate = res.data.orderStatusExpireDate
                }
            })
        },
        filterNumbers (evt) {
            evt = evt || window.event
            let expect = evt.target.value.toString() + evt.key.toString()
            if (!/^[0-9]*$/.test(expect)) {
                evt.preventDefault()
            } else {
                return true
            }
        },
        addOrderIdToRoute (id) {
            if (!this.$route.query.orderId) {
                this.$router.replace('/order-divorce-certificate?orderId=' + id)
            }
        }
    }
}
</script>
